import styled from "styled-components";
import { SlimScrollStyle } from "../../styles/common.style";

const SearchStyle = styled.div`
  padding: 0px;
  color: white;
  min-height: calc(100vh - 64px);
  background: #0B0F1B;
  display: flex;
  flex-direction: column;
`;

const SearchHeader = styled.div`
  background: #0B0F1B;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px 0 32px;

  .search-header-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;

    @media (max-width: 768px) {
      padding: 0 16px;
    }
  }

  .search-title-section {
    text-align: center;
    margin-bottom: 32px;

    .search-page-title {
      font-size: 48px;
      font-weight: 700;
      color: white;
      margin: 0 0 12px 0;
      font-family: 'Poppins', sans-serif;
      background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;

      @media (max-width: 768px) {
        font-size: 36px;
      }

      @media (max-width: 480px) {
        font-size: 28px;
      }
    }

    .search-page-subtitle {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.7);
      margin: 0;
      font-weight: 400;
      font-family: 'Poppins', sans-serif;
      max-width: 600px;
      margin: 0 auto;
      line-height: 1.5;

      @media (max-width: 768px) {
        font-size: 16px;
      }

      @media (max-width: 480px) {
        font-size: 14px;
      }
    }
  }

  .search-controls-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 20px;
    }
  }

  .search-bar-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 400px;
    max-width: 600px;
    flex: 1;

    @media (max-width: 768px) {
      min-width: 100%;
      max-width: 100%;
    }
  }

`;

const SearchContent = styled.div`
  flex: 1;
  padding: 0;

  .ant-table {
    ${SlimScrollStyle};
    max-height: 70vh;
    overflow: auto;
    background: transparent;

    @media (max-width: 600px) {
      max-height: calc(100vh - 300px);
    }
  }

  .song-title {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .song-artist {
    max-width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-pagination {
    justify-content: center;
  }

  /* Hide the mobile search bar since we have it in header now */
  .searchBarBrowse {
    display: none !important;
  }
`;
export { SearchStyle, SearchHeader, SearchContent };
